import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { GenericFormService } from './service/generic-form.service';
import { Subject, takeUntil } from 'rxjs';
import { FieldModel } from './model/field.model';

@Component({
	selector: 'cv-form-field',
	templateUrl: './form-field.component.html',
	styleUrls: [ './form-field.component.scss' ]
})
export class FormFieldComponent implements OnInit, OnDestroy {

	@ViewChild('reviewField', {read: ElementRef, static: false}) reviewField: ElementRef;
	@Input() options: any;
	@Input() model: any;
	formControl: FormControl;
	public field: FieldModel;
	value: any;

	private atComponentDestroy = new Subject();

	get form(): FormGroup {
		return this.formService.form;
	}

	get dataModel(): any {
		return this.formService.dataModel;
	}

	get formFieldList(): any {
		return this.formService.formFieldList;
	}

	constructor(
		private formService: GenericFormService
	) {
		//
	}

	async ngOnInit(): Promise<void> {
		await this.setFormControl()
		await this.setField();
		await this.setValue();
		await this.setValidations();

		this.form.valueChanges.pipe(takeUntil(this.atComponentDestroy)).subscribe(async data => {
			await this.setValue();
		});
	}

	/**
	 * Set the field different paths,
	 */
	async setField(): Promise<void> {
		this.field = this.formFieldList[this.options.key];
		if ('childKey' in this.options) {
			this.field = this.formFieldList[this.options.key].child[this.options.index][this.options.childKey];
		}

		if ('label' in this.options) {
			const newLabels = {
				UILabel: this.options.label,
				DisplayText: this.options.label
			};
			Object.assign(this.field, newLabels);
		}
	}

	/**
	 * Set the value of the field
	 */
	async setValue(): Promise<void> {
		this.value = '';
		this.value = this.formControl.value;
	}

	/**
	 * initialize formcontrol from the given path
	 */
	async setFormControl(): Promise<any> {
		let formData: any = this.form;
		if (this.formService.dataModel?.constructor === Array) {
			const index = this.formService.dataModel.findIndex(element => element.key === this.options.key);
			formData = formData.at(index) as FormControl;
		} else {
			formData = this.form?.get(this.options.key) as FormControl;

			if (this.options.path) {
				formData = this.form?.get(this.options.path) as FormControl;
			}

			if ('childKey' in this.options) {
				formData = this.form?.get(this.options.key) as FormArray;
				formData = formData.at(this.options.index).get(this.options.childKey);
			}
		}
		this.formControl = formData;
	}

	/**
	 *
	 */

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}

	async setValidations(): Promise<void> {
		this.formControl.setValidators([ Validators.required ]);

		if (this.field && 'required' in this.field && !this.field?.required) {
			this.formControl.setValidators([]);
		}

		if (this.options.minlength) {
			this.formControl.addValidators(Validators.minLength(this.options.minlength));
		}

		this.formControl.updateValueAndValidity({onlySelf: true});
		this.form.updateValueAndValidity();
	}
}
